<div class="card sales-1 overflow-hidden rounded-10 shadow">
  <div class="card-body" *ngIf="isLoaded">
    <app-loading-dash [size]="'card-top'" />
  </div>
  <div class="card-body" *ngIf="!isLoaded">
    <span class="bg-primary-transparent icon-service text-primary float-end"
      ><i class="fe fe-briefcase"></i>
    </span>
    <h6 class="mb-3">{{ 'common.averageDailyTicket' | translate }}</h6>
    <h4 class="mb-1">
      <span class="number-font"
        >
        <span class="counter">{{
          averageSales
            | formatCurrency
        }}</span></span
      >
    </h4>
    <p class="mb-2" *ngIf="!averageSalesPositive">
      <span class="text-danger fs-13 me-2"
        >(-{{
          averageSalesPercent
            | mask : "separator.2" : { decimalMarker: ",", leadZero: true }
        }}%)</span
      >
      <span class="small text-muted">{{ 'common.thanLastWeek' | translate}}</span>
    </p>
    <p class="mb-2" *ngIf="averageSalesPositive">
      <span class="text-success fs-13 me-2"
        >({{
          averageSalesPercent
            | mask : "separator.2" : { decimalMarker: ",", leadZero: true }
        }}%)</span
      >
      <span class="small text-muted">{{ 'common.thanLastWeek' | translate}}</span>
    </p>
  </div>
</div>
